import { QueryClient } from "@tanstack/vue-query";

import { singleton } from "@solvari/utils";

const useQueryClient = singleton(() => {
  return new QueryClient();
});

export { useQueryClient };
